import React from 'react';
import { Box, HStack, IconButton, useMediaQuery } from '@chakra-ui/react';
import { BsThreeDotsVertical } from 'react-icons/bs';

function RightSection({ isExpanded, toggleExpand, colors, content: Content }) {
  const [isMobile] = useMediaQuery('(max-width: 768px)'); // Detect mobile screen

  // Don't render the right section on mobile screens
  if (isMobile) {
    return null;
  }

  const handleClick = (e) => {
    // Stop toggle when clicking on certain child elements
    if (e.target.tagName === 'INPUT' || e.target.closest('.no-toggle')) {
      e.stopPropagation();
      return;
    }
    toggleExpand();
  };

  return (
    <Box
    onClick={!isExpanded ? handleClick : undefined}
      position="relative"
      w={isExpanded ? '42%' : '0%'} // Expand and collapse the right section
      transition="width 0.4s ease"
      bg="white"
      borderWidth="6px"
      // borderColor={colors.sidebarBg}
      borderLeft="none"
      mt={5}
      mb={5}
      // overflowY='auto'
      p={isExpanded ? '6' : '1'}
      borderRadius="1px 20px 20px 1px" // Set top-left & top-right to 20px and bottom-left & bottom-right to 1px
      minH="700px" // Matches the height of the left section
      maxH="700px" // Matches the height of the left section

    >
      <HStack justify="right" align="center" mb={4}>
        <IconButton
          icon={<BsThreeDotsVertical />}
          onClick={toggleExpand}
          aria-label="Expand Section"
          bg="none"
          _hover={{ bg: 'none' }} // Prevent background on hover
          _active={{ bg: 'none' }} // Prevent background on click
        />
      </HStack>

      {isExpanded && Content && (
        <Box mt={4}>
          {/* Render the dynamic content */}
          <Content />
        </Box>
      )}
    </Box>
  );
}

export default RightSection;
